import { render, staticRenderFns } from "./baocuo.vue?vue&type=template&id=58ac861a&scoped=true&"
import script from "./baocuo.vue?vue&type=script&lang=js&"
export * from "./baocuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac861a",
  null
  
)

export default component.exports